import { render, staticRenderFns } from "./liveInfo.vue?vue&type=template&id=04a0801e&scoped=true"
import script from "./liveInfo.vue?vue&type=script&lang=js"
export * from "./liveInfo.vue?vue&type=script&lang=js"
import style0 from "./liveInfo.vue?vue&type=style&index=0&id=04a0801e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a0801e",
  null
  
)

export default component.exports